// Shared formatting helpers.

// "2024-25" → "24-25", "2024" → "24"
export const shortSeason = (s) =>
    String(s || "")
        .split("-")
        .map((p) => (p.length === 4 ? p.slice(2) : p))
        .join("-");
